// Copyright (c) 2017 Deere & Company

import SearchFilters from '../../shared/state/search-filters';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateListFilterBy = (state, action) =>
    SearchFilters.update(state, {
        filterBy: {
            $set: action.value
        }
    });

const updateListSortBy = (state, action) =>
    SearchFilters.update(state, {
        sortBy: {
            $set: action.value
        }
    });

const updateListSortDirection = (state, action) =>
    SearchFilters.update(state, {
        sortDirection: {
            $set: action.value
        }
    });

export default (state = getDefaultState().searchFilters, action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_LIST_FILTER_BY]: updateListFilterBy,
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_LIST_SORT_BY]: updateListSortBy,
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_LIST_SORT_DIRECTION]: updateListSortDirection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/search-filters.js